// ds-guard-ignore: vi phạm có sẵn trước khi chuyển từ components (C3)
import styled from 'styled-components'

export const StyleMenuAccount = styled.div<{ isDarkMode?: boolean }>`
  .menu-account {
    padding: 2px;
    margin-top: 4px;
    min-width: 220px;
    .account-name {
      line-height: 1.2;
    }
    .header-avatar-rainbow {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      padding: 2px;
      background: linear-gradient(
        135deg,
        var(--vbdt-color-status-warning),
        var(--vbdt-color-status-error),
        var(--vbdt-color-accent-base),
        var(--vbdt-color-status-info),
        var(--vbdt-color-status-success)
      );

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        display: block;
        background-color: var(--vbdt-color-bg-surface);
      }
    }
    .btn-logout {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      font-size: 14px !important;
      font-weight: 600;
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: var(--vbdt-color-status-error);
          }
        }
      }
    }
    
    .btn-function {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      font-size: 14px !important;
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: var(--vbdt-color-text-tertiary);
          }
        }
      }
    }
    .strok-btn-function {
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: var(--vbdt-color-text-tertiary);
            stroke: var(--vbdt-color-text-tertiary);
          }
        }
      }
    }
    .ant-dropdown-menu-item {
      background: var(--vbdt-color-bg-elevated) !important;
      padding: 2px 0px;
    }
    .ant-dropdown-menu-item:hover {
      background: var(--vbdt-color-bg-hover) !important;
    }
    .ant-dropdown-menu,
    .ant-menu,
    .ant-menu-root {
      position: relative !important;
      width: 100% !important;
      padding: 0 !important;
      box-shadow: unset;
      background: none;
      border: none !important;
      border-right: none !important;
      &::after {
        display: none !important;
      }
      .account-infor {
        background: var(--vbdt-color-bg-elevated);
        padding: 6px 12px 0px 12px;
        border-radius: 20px 20px 3px 3px;
        margin-bottom: 0px;
        .ant-divider {
          margin: 6px 0px 2px 0px;
        }
        .infor {
          margin-bottom: 2px;
        }
        .sumary-infor-user {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          height: 100%;
        }
      }
      .account-function {
        background: var(--vbdt-color-bg-elevated);
        padding: 6px 12px;
        border-radius: 3px;
        margin-bottom: 2px;
      }
      .account-logout {
        background: var(--vbdt-color-bg-elevated);
        padding: 6px 12px;
        border-radius: 3px 3px 20px 20px;
      }
    }
  }
`
